import "./Alexa.css"
import Product1 from "../Components/Product1"

import Alexa11 from "../images/alexa1.webp"
import Alexa2 from "../images/alexa2.webp"
import Alexa3 from "../images/alexa3.webp"
import Alexa4 from "../images/alexa4.webp"
import Alexa5 from "../images/alexa5.webp"
import Alexa6 from "../images/alexa6.webp"
import Alexa7 from "../images/alexa7.webp"
import Alexa8 from "../images/alexa8.jpg"


export default function Alexa1() {

  return (
    <div className="stdivinhome">
   
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="alexa1" prdName="ECHO_I3" img={Alexa11} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="alexa2"prdName="ECHO_I5" img={Alexa2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="alexa3" prdName="ECHO_WHITE" img={Alexa3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="alexa4"prdName="ECHO_BULB" img={Alexa4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="alexa5"prdName="ECHO_WHITE" img={Alexa5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1  id="alexa6"prdName="ECHO_BULBS" img={Alexa6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="alexa7"prdName="ECHO_SHOW8" img={Alexa7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="alexa8"prdName="ECHO_HALO3" img={Alexa8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}